import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { PublicLayout } from "@/components/public/PublicLayout";
import { Analytics } from "@/components/Analytics";

import Home from "@/pages/public/Home";
import Inventory from "@/pages/public/Inventory";
import BoatDetail from "@/pages/public/BoatDetail";
import Brands from "@/pages/public/Brands";
import BrandPage from "@/pages/public/BrandPage";
import Service from "@/pages/public/Service";
import About from "@/pages/public/About";
import Contact from "@/pages/public/Contact";
import Financing from "@/pages/public/Financing";
import LocationPage from "@/pages/public/LocationPage";
import SeoPage from "@/pages/public/SeoPage";

import Login from "@/pages/admin/Login";
import { AdminLayout } from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import InventoryList from "@/pages/admin/InventoryList";
import BoatForm from "@/pages/admin/BoatForm";
import ModelSpecs from "@/pages/admin/ModelSpecs";
import Leads from "@/pages/admin/Leads";
import SiteContent from "@/pages/admin/SiteContent";
import SeoAdmin from "@/pages/admin/SeoAdmin";
import Promotions from "@/pages/admin/Promotions";
import Settings from "@/pages/admin/Settings";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Analytics />
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/inventory" element={<Inventory />} />
              <Route path="/boats/:slug" element={<BoatDetail />} />
              <Route path="/brands" element={<Brands />} />
              <Route path="/brands/:key" element={<BrandPage />} />
              <Route path="/service" element={<Service />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/financing" element={<Financing />} />
              <Route path="/locations/:slug" element={<LocationPage />} />
              <Route path="/guides/:slug" element={<SeoPage />} />
            </Route>

            <Route path="/admin/login" element={<Login />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="inventory" element={<InventoryList />} />
              <Route path="inventory/new" element={<BoatForm />} />
              <Route path="inventory/:id" element={<BoatForm />} />
              <Route path="models" element={<ModelSpecs />} />
              <Route path="leads" element={<Leads />} />
              <Route path="site" element={<SiteContent />} />
              <Route path="seo" element={<SeoAdmin />} />
              <Route path="promotions" element={<Promotions />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
